import { Modal } from 'react-bootstrap';
import { ManualForm } from './ManualForm';
import type { Manual, UpdateManualRequest } from '../../../infrastructure/ManualClient';

interface UpdateManualModalProps {
  show: boolean;
  manual: Manual;
  onHide: () => void;
  onSubmit: (data: UpdateManualRequest) => void;
  isSubmitting: boolean;
}

export const UpdateManualModal = ({ show, manual, onHide, onSubmit, isSubmitting }: UpdateManualModalProps) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit Manual</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ManualForm initialData={manual} onSubmit={onSubmit} isSubmitting={isSubmitting} />
      </Modal.Body>
    </Modal>
  );
};
